export const documents = [
  {
    id: 'doc_001',
    organizationId: 'org_3la_labs',
    name: 'Contrato XPTO Tecnologia.pdf',
    category: 'Contratos',
    date: '15/07/2026',
    size: '1.2 MB',
    owner: 'Luan Cesar',
    relatedTo: 'Empresa XPTO Tecnologia',
  },
  {
    id: 'doc_002',
    organizationId: 'org_3la_labs',
    name: 'NFS-e 000245.pdf',
    category: 'Notas fiscais',
    date: '01/09/2026',
    size: '245 KB',
    owner: 'Luan Cesar',
    relatedTo: 'Empresa XPTO Tecnologia',
  },
  {
    id: 'doc_003',
    organizationId: 'org_3la_labs',
    name: 'Comprovante PIX XPTO.pdf',
    category: 'Comprovantes',
    date: '04/09/2026',
    size: '180 KB',
    owner: 'Luan Cesar',
    relatedTo: 'Empresa XPTO Tecnologia',
  },
  {
    id: 'doc_004',
    organizationId: 'org_3la_labs',
    name: 'Contrato Social 3LA Labs.pdf',
    category: 'Documentos da empresa',
    date: '10/01/2024',
    size: '3.4 MB',
    owner: 'Luan Cesar',
    relatedTo: '3LA Labs',
  },
  {
    id: 'doc_005',
    organizationId: 'org_3la_labs',
    name: 'Proposta Emsoft Solutions.pdf',
    category: 'Documentos de clientes',
    date: '22/08/2026',
    size: '890 KB',
    owner: 'Luan Cesar',
    relatedTo: 'Emsoft Solutions',
  },
  {
    id: 'doc_006',
    organizationId: 'org_3la_labs',
    name: 'Política de privacidade.docx',
    category: 'Outros',
    date: '05/05/2026',
    size: '420 KB',
    owner: 'Luan Cesar',
    relatedTo: '3LA Labs',
  },
];

export const documentCategories = [
  'Contratos',
  'Notas fiscais',
  'Comprovantes',
  'Documentos da empresa',
  'Documentos de clientes',
  'Outros',
];
